import React from "react";
import ReactDOM from "react-dom/client";
import { getCalApi } from "@calcom/embed-react";
import App from "./App";
import "./styles/index.css";
import { initObservability } from "./lib/observability";
import { CAL_NAMESPACE, CAL_BRAND_COLOR } from "./lib/cal-config";
import { trackCompletedBookings } from "./lib/book-a-call";

initObservability();

void (async () => {
  const cal = await getCalApi({ namespace: CAL_NAMESPACE });
  cal("ui", {
    theme: "light",
    cssVarsPerTheme: { light: { "cal-brand": CAL_BRAND_COLOR } },
    hideEventTypeDetails: false,
    layout: "month_view",
  });
})();
void trackCompletedBookings();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
